import React from 'react';

function FraudDetection() {
  return (
    <div style={{ padding: 32 }}>
      <h2>AI Fraud Detection</h2>
      <p style={{ maxWidth: 600, marginBottom: 32 }}>
        Analyze customs and freight shipments for potential fraud using AI. In the Customs or Freight modules, click <b>Analyze for Fraud</b> on any shipment to get a risk assessment.<br/>
        <br/>
        <b>Examples:</b>
        <ul style={{ marginTop: 10 }}>
          <li>High shipment value or suspicious country may trigger a fraud alert.</li>
          <li>Normal shipments will show "No Fraud Detected".</li>
          <li>Results include a confidence score and explanation.</li>
        </ul>
      </p>
      <div style={{ background: '#f4f6fa', padding: 24, borderRadius: 10, color: '#888', fontStyle: 'italic' }}>
        Fraud detection results will appear in a popup when you analyze a shipment.
      </div>
    </div>
  );
}

export default FraudDetection; 